export function getStageLabel(
  pipelines: any[],
  pipelineId: string | null,
  stageId: string | null,
) {
  if (pipelineId === null || stageId === null) return "";

  const pipeline = pipelines.find(p => p.id === pipelineId);
  if (!pipeline) return "";

  const stage = pipeline.stages.find((s: any) => s.id === stageId);
  if (!stage) return "";

  return stage.label ?? "";
}

export function getStagePipelineId(pipelines: any[], stageId: string | null) {
  if (stageId === null) return null;

  for (const pipeline of pipelines) {
    for (const stage of pipeline.stages) {
      if (stage.id === stageId) return pipeline.id;
    }
  }

  return null;
}

export function getStageProbability(
  pipelines: any[],
  pipelineId: string | null,
  stageId: string | null,
  fromHistoricalData = false,
) {
  if (pipelineId === null || stageId === null) return 1;

  if (fromHistoricalData) {
    // NOTE: Hardcoding tendium updated probabilities
    // Do it better by using database
    if (stageId === "1144066913") return 0.375;
    if (stageId === "1144066915") return 0.412;
    if (stageId === "1144066916") return 0.298;
    if (stageId === "1143716649") return 0.643;
    if (stageId === "1149792853") return 0.766;
    if (stageId === "1143716650") return 0.998;

    // NOTE: Hardcoded Two updated probabilities
    // Really need the database now
    if (stageId === "12260273") return 0.09;
    if (stageId === "12260275") return 0.14;
    if (stageId === "1005073") return 0.23;
    if (stageId === "4528822") return 0.43;
    if (stageId === "12260277") return 0.48;
    if (stageId === "106241308") return 0.6;
    if (stageId === "87381263") return 0.67;
    if (stageId === "1030027545") return 0.94;
    if (stageId === "87456651") return 1;
  }

  const pipeline = pipelines.find(p => p.id === pipelineId);
  if (!pipeline) return 1;

  const stage = pipeline.stages.find((s: any) => s.id === stageId);
  if (!stage) return 1;

  return stage.metadata?.probability ? Number(stage.metadata.probability) : 1;
}

export function getRevelateStageProbabilityForDeal(
  pipelines: any[],
  deal: {
    pipeline?: string | null;
    provider_data?: { properties?: { dealstage?: string | null } } | null;
    stage_probability_adjusted?: number | string | null;
  },
) {
  const prepared = Number(deal.stage_probability_adjusted);
  if (
    deal.stage_probability_adjusted !== null
    && deal.stage_probability_adjusted !== undefined
    && deal.stage_probability_adjusted !== ""
    && Number.isFinite(prepared)
    && prepared >= 0
    && prepared <= 1
  ) return prepared;

  return getStageProbability(
    pipelines,
    deal.pipeline ?? null,
    deal.provider_data?.properties?.dealstage ?? null,
    true,
  );
}

export function getPipelineLabel(
  pipelines: any[],
  pipelineId: string | null,
) {
  if (!pipelineId) return "";

  const pipeline = pipelines.find(p => p.id === pipelineId);
  if (!pipeline) return pipelineId;

  return pipeline.label ?? pipelineId;
}

function isFirstStageEarlierThanSecond(
  firstStageId: string,
  secondStageId: string,
  pipelines: any[],
) {
  // First find the pipeline
  const pipeline = pipelines.find(p => {
    const stageIds = p.stages.map((s: any) => s.id);
    return stageIds.includes(firstStageId);
  });

  if (!pipeline) return false;

  // Then compare their probabilities

  const firstStageProbability = pipeline.stages.find((s: any) => s.id === firstStageId)?.metadata?.probability;
  const secondStageProbability = pipeline.stages.find((s: any) => s.id === secondStageId)?.metadata?.probability;

  if (!firstStageProbability || !secondStageProbability) return false;

  return Number(firstStageProbability) < Number(secondStageProbability);
}

export function findNumStageRegressions(dealstageHistory: any[], pipelines: any[]) {
  // Step 1: sort by timestamp (ascending)
  const sorted = dealstageHistory.toSorted(
    // @ts-ignore
    (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
  );

  // Step 2: find regressions
  let numRegressions = 0;

  for (let i = 0; i < sorted.length - 1; i++) {
    const current = sorted[i];
    const next = sorted[i + 1];

    const currentStage = current.value;
    const nextStage = next.value;

    const regressed = isFirstStageEarlierThanSecond(nextStage, currentStage, pipelines);
    if (regressed) numRegressions += 1;
  }

  return numRegressions;
}
